import { render, staticRenderFns } from "./ViewAllOrders.vue?vue&type=template&id=fb838da2&scoped=true&"
import script from "./ViewAllOrders.vue?vue&type=script&lang=js&"
export * from "./ViewAllOrders.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllOrders.vue?vue&type=style&index=0&id=fb838da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb838da2",
  null
  
)

export default component.exports